import { render } from "./UbahKatalaluan.vue?vue&type=template&id=303591e4&scoped=true"
import script from "./UbahKatalaluan.vue?vue&type=script&lang=js"
export * from "./UbahKatalaluan.vue?vue&type=script&lang=js"

import "./UbahKatalaluan.vue?vue&type=style&index=0&id=303591e4&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303591e4"]])

export default __exports__